import React, {useState,useEffect, useMemo} from 'react'
import {defaultSettings, ISettings} from '../modules/profile/components/settings/SettingsModel'
import {defaultAccount, IAccount} from './MyAccountModel'
import Popup from './Popup';
import './style.css';
import region from './address/region.json'
import city from './address/city.json'
import companyLogo from './Avision_Logo.png';
import {db, storage} from './firebase';
import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
import { collection, addDoc } from "firebase/firestore";
import liff from '@line/liff';
import connectWeb from'./configconnect/WebConnectionSetup.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhoneVolume, faEnvelope } from '@fortawesome/free-solid-svg-icons'
// import { faPhoneVplume } from '@fortawesome/free-regular-svg-icons'
import Badge from 'react-bootstrap/Badge';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";
import { styleSetupConfig } from '../configs/style-config';
import { initialStore } from '../stores/init_config_store';

export function Contact() {
  //AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
  const logo = initialStore((state) => state.logo);
  //C-AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
  useEffect(() => {


    const getAllData = async () => {
      // await setDataAddress();
      await setfileconfig()


    };

    getAllData();

    // setStateCounty(ssssss)
  },[])

  const [logoImageweb, setLogoImageweb] = useState('');
  async function setfileconfig() {
    const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
    const storageRef_logoweb = ref_storage(storage, setupwebdefault.club_logo_path);
    getDownloadURL(storageRef_logoweb).then((url) => {
      setLogoImageweb(url)
    });
  }
  let stylesweb = JSON.parse(""+window.sessionStorage.getItem('stylesetup'));
  //AVCDAMOSHI.001  17/03/2025  Add code for Reuse style setupweb
  const styles = useMemo(() => styleSetupConfig(stylesweb), [stylesweb]);
  //C-AVCDAMOSHI.001  17/03/2025  Add code for Reuse style setupweb

  // const styles = {
  //   title_style: {
  //     "backgroundColor": stylesweb.title_style.background_color,
  //     "border": stylesweb.title_style.border,
  //     "border-color": stylesweb.title_style.border_color,
  //     "border-radius":stylesweb.title_style.border_radius,
  //     "color": stylesweb.title_style.font_color,
  //     "font-family": stylesweb.title_style.font_name,
  //     "font-size": stylesweb.title_style.font_size,
  //     "font-weight": stylesweb.title_style.font_weight,
  //   },
  //   title2_style: {
  //     "backgroundColor": stylesweb.title2_style.background_color,
  //     "border": stylesweb.title2_style.border,
  //     "border-color": stylesweb.title2_style.border_color,
  //     "border-radius":stylesweb.title2_style.border_radius,
  //     "color": stylesweb.title2_style.font_color,
  //     "font-family": stylesweb.title2_style.font_name,
  //     "font-size": stylesweb.title2_style.font_size,
  //     "font-weight": stylesweb.title2_style.font_weight,
  //   },
  //   caption_style: {
  //     "backgroundColor": stylesweb.caption_style.background_color,
  //     "border": stylesweb.caption_style.border,
  //     "border-color": stylesweb.caption_style.border_color,
  //     "border-radius":stylesweb.caption_style.border_radius,
  //     "color": stylesweb.caption_style.font_color,
  //     "font-family": stylesweb.caption_style.font_name,
  //     "font-size": stylesweb.caption_style.font_size,
  //     "font-weight": stylesweb.caption_style.font_weight,
  //   },
  //   input_data_style: {
  //     "backgroundColor": stylesweb.input_data_style.background_color,
  //     "border": stylesweb.input_data_style.border,
  //     "border-color": stylesweb.input_data_style.border_color,
  //     "border-radius":stylesweb.input_data_style.border_radius,
  //     "color": stylesweb.input_data_style.font_color,
  //     "font-family": stylesweb.input_data_style.font_name,
  //     "font-size": stylesweb.input_data_style.font_size,
  //     "font-weight": stylesweb.input_data_style.font_weight,
  //   },
  //   title_consent_style: {
  //     "backgroundColor": stylesweb.title_consent_style.background_color,
  //     "border": stylesweb.title_consent_style.border,
  //     "border-color": stylesweb.title_consent_style.border_color,
  //     "border-radius":stylesweb.title_consent_style.border_radius,
  //     "color": stylesweb.title_consent_style.font_color,
  //     "font-family": stylesweb.title_consent_style.font_name,
  //     "font-size": stylesweb.title_consent_style.font_size,
  //     "font-weight": stylesweb.title_consent_style.font_weight,
  //   },
  //   description_consent_style: {
  //     "backgroundColor": stylesweb.description_consent_style.background_color,
  //     "border": stylesweb.description_consent_style.border,
  //     "border-color": stylesweb.description_consent_style.border_color,
  //     "border-radius":stylesweb.description_consent_style.border_radius,
  //     "color": stylesweb.description_consent_style.font_color,
  //     "font-family": stylesweb.description_consent_style.font_name,
  //     "font-size": stylesweb.description_consent_style.font_size,
  //     "font-weight": stylesweb.description_consent_style.font_weight,
  //   },
  //   consent_page_style_body: {
  //     "backgroundColor": stylesweb.consent_page_style.background_color,
  //     "border": stylesweb.consent_page_style.border,
  //     "border-color": stylesweb.consent_page_style.border_color,
  //     "color": stylesweb.consent_page_style.font_color,
  //     "font-family": stylesweb.consent_page_style.font_name,
  //     "font-size": stylesweb.consent_page_style.font_size,
  //     "font-weight": stylesweb.consent_page_style.font_weight,
  //   },
  //   consent_page_style_header: {
  //     "backgroundColor": stylesweb.consent_page_style.background_color,
  //     "border": stylesweb.consent_page_style.border,
  //     "border-color": stylesweb.consent_page_style.border_color,
  //     "border-top-left-radius": stylesweb.consent_page_style.border_radius,
  //     "border-top-right-radius": stylesweb.consent_page_style.border_radius,
  //     "color": stylesweb.consent_page_style.font_color,
  //     "font-family": stylesweb.consent_page_style.font_name,
  //     "font-size": stylesweb.consent_page_style.font_size,
  //     "font-weight": stylesweb.consent_page_style.font_weight,
  //   },
  //   consent_page_style_footer: {
  //     "backgroundColor": stylesweb.consent_page_style.background_color,
  //     "border": stylesweb.consent_page_style.border,
  //     "border-color": stylesweb.consent_page_style.border_color,
  //     "border-bottom-left-radius": stylesweb.consent_page_style.border_radius,
  //     "border-bottom-right-radius": stylesweb.consent_page_style.border_radius,
  //     "color": stylesweb.consent_page_style.font_color,
  //     "font-family": stylesweb.consent_page_style.font_name,
  //     "font-size": stylesweb.consent_page_style.font_size,
  //     "font-weight": stylesweb.consent_page_style.font_weight,
  //   },

  //   error_message_box_style: {
  //     "backgroundColor": stylesweb.error_message_box_style.background_color,
  //     "border": stylesweb.error_message_box_style.border,
  //     "border-color": stylesweb.error_message_box_style.border_color,
  //     "border-radius": stylesweb.error_message_box_style.border_radius,
  //     "color": stylesweb.error_message_box_style.font_color,
  //     "font-family": stylesweb.error_message_box_style.font_name,
  //     "font-size": stylesweb.error_message_box_style.font_size,
  //     "font-weight": stylesweb.error_message_box_style.font_weight,
  //   },
  //   foreground_Style: {
  //     "backgroundColor": stylesweb.foreground_Style.background_color,
  //     "border": stylesweb.foreground_Style.border,
  //     "border-color": stylesweb.foreground_Style.border_color,
  //     "border-radius": stylesweb.foreground_Style.border_radius,
  //     "color": stylesweb.foreground_Style.font_color,
  //     "font-family": stylesweb.foreground_Style.font_name,
  //     "font-size": stylesweb.foreground_Style.font_size,
  //     "font-weight": stylesweb.foreground_Style.font_weight,
  //   },
  //   background_Style: {
  //     "backgroundColor": stylesweb.background_Style.background_color,
  //     "border": stylesweb.background_Style.border,
  //     "border-color": stylesweb.background_Style.border_color,
  //     "border-radius": stylesweb.background_Style.border_radius,
  //     "color": stylesweb.background_Style.font_color,
  //     "font-family": stylesweb.background_Style.font_name,
  //     "font-size": stylesweb.background_Style.font_size,
  //     "font-weight": stylesweb.background_Style.font_weight,
  //   }

  // };
  	return (
        <div className='card card-homepage main-custom-container'>
            <div className='row mb-8 imagelogo' style={styles.background_Style}>
                <img src={logo} alt="metronic"/>
            </div>
            <div className='card-body-homepage-middle '>
                <div className='block-homepage showbody' style={styles.foreground_Style} >
                    <div className='block-homepage-body'>
                        <div className="d-flex justify-content-center mt-5 pt-5">
                            <h1>ติดต่อเรา</h1>
                        </div>
                        <div className="mt-5 pt-5 d-flex">
                            <div className="col-5 d-flex justify-content-center">
                                {/* <Badge pill  bg="info"> */}
                                    <FontAwesomeIcon icon={faLocationDot}  size="3x" 
                                    //AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setupweb
                                    // className="text-info" 
                                    style={styles.icon_style}
                                    //C-AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setupweb
                                    />
                                {/* </Badge> */}
                            </div>
                            <div className="col-7 d-flex justify-content-start">
                                {/*avnsd*/}
                                {/*<h5 className="text-dark-50">979/49-50 SM Tower ชั้น 20 ถนน พหลโยธิน สามเสนใน พญาไท กรุงเทพฯ 10400 ประเทศไทย</h5>*/}
                                <h5 className="text-dark-50"
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.caption_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >44 ชั้น 14 อาคารสมูทไลฟ์ทาวเวอร์ ถนนสาทรเหนือ แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500</h5>
                                {/*avnsd*/}
                            </div>
                        </div>
                        <div className="mt-5 pt-5 d-flex">
                            <div className="col-5 d-flex justify-content-center">
                                {/* <Badge pill  bg="info"> */}
                                    <FontAwesomeIcon icon={faPhoneVolume}  size="3x" 
                                    //AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setupweb
                                    // className="text-info" 
                                    style={styles.icon_style}
                                    //C-AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setupweb
                                    />
                                {/* </Badge> */}
                            </div>
                            <div className="col-7 d-flex justify-content-start">
                                {/*avnsd*/}
                                {/*<h5 className="text-dark-50 pt-3">+66 (0) 2 916 5838-9</h5>*/}
                                <h5 className="text-dark-50 pt-3"
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.caption_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >081-234-9315 <br></br>เวลาทำการ <br></br>จันทร์-ศุกร์<br></br> 09:00 - 17:00 น.</h5>
                                {/*avnsd*/}
                            </div>
                        </div>
                        <div className="mt-5 pt-5 d-flex">
                            <div className="col-5 d-flex justify-content-center">
                                {/* <Badge pill  bg="info"> */}
                                    <FontAwesomeIcon icon={faEnvelope}  size="3x" 
                                    //AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setupweb
                                    // className="text-info" 
                                    style={styles.icon_style}
                                    //C-AVCDAMOSHI.001  17/03/2025  Add code for  Reuse style setupweb
                                    />
                                {/* </Badge> */}
                            </div>
                            <div className="col-7 d-flex justify-content-start">
                                {/*avnsd*/}
                                {/*<h5 className="text-dark-50 pt-3">sales@avision.co.th</h5>*/}
                                <h5 className="text-dark-50 pt-3"
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.caption_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >customerservice @pnfsmoothlife.com</h5>
                                {/*avnsd*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  	)
}
